module.exports = __webpack_public_path__ + "static/media/banner.fba8a5a3.png";